export const ccpaScriptSource = "https://privacy.claytonhomes.com/ccpa/v5/index.min.js";